<template>
  <div class='searchList'>
    <el-menu v-if="item.hasOwnProperty('webSearchList')" default-active="1" class="el-menu-vertical-demo">
      <el-submenu index="1">
        <template slot="title">
          <!-- <span class="search-title" v-if="item.websearchState == 1">{{ $i18.language("正在尝试为您在互联网搜索相关资料...") }}</span> -->
          <span class="search-title" v-if="item.websearchState != 1 && item.webSearchList && item.webSearchList.length > 0">{{ webSearchListFormat[item.webSearchList.length - 1].text }}</span>
        </template>
        <div class="menu_box" v-if="item.webSearchList && webSearchListFormat.length > 0">
          <div class="menu_top" v-for="(el, idx) in webSearchListFormat" :key="idx">
            <a v-if="el.value" :href="el.value" target="_blank">{{ el.text }}</a>
            <span v-else>{{ el.text }}</span>
          </div>
        </div>
      </el-submenu>
    </el-menu>
    <el-menu v-if="item.searchType=='yisou'" default-active="1" class="el-menu-vertical-demo">
      <el-submenu index="1">
        <template slot="title">
          <span class="search-title" v-if="item.searchText.length > 0">{{ TextToArray[TextToArray.length - 1] }}</span>
        </template>
        <span class="searchText">{{ item.searchText }}</span>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
    }
  },
  data() {
    return {

    };
  },
  computed: {
    TextToArray() {
      return this.item.searchText.split(/\n+/).filter(e=>e!="")
    },
    webSearchListFormat() {
      let list = JSON.parse(JSON.stringify(this.item.webSearchList))
      list.forEach(item => {
        item.text = item.text.replace("正在尝试为您在互联网搜索相关资料...", this.$i18.language("正在尝试为您在互联网搜索相关资料..."))
        item.text = item.text.replace("共找到了", this.$i18.language("共找到了 "))
        item.text = item.text.replace("篇资料作为参考：", this.$i18.language(" 篇资料作为参考："))
        item.text = item.text.replace("暂未检索到互联网相关资料", this.$i18.language("暂未检索到互联网相关资料"))
      })
      return list
    }
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
.el-menu-vertical-demo {
  background: unset;
  padding: 0;
  border: 0;
  .el-submenu {
    .el-menu--inline {
      padding: 0;
      .menu_box {
        margin: 8px 0;
        .menu_top {
          height: 28px;
          line-height: 28px;
          overflow: hidden;
        }
      }
    }
    .searchText {
      white-space: break-spaces;
      line-height: 2;
      margin: 8px 0;
      display: block;
    }
    /deep/ .el-submenu__title {
      height: 45px;
      line-height: 45px;
      max-width: 450px;
      background: #fff;
      border-radius: 15px;
      margin-bottom: 10px;
      .search-title {
        display: inline-block;
        width: 95%;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;
      }
    }
    /deep/ .el-menu--inline {
      border-radius: 15px;
      margin-bottom: 10px;
    }
  }
}
</style>
